<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="603px" :show-close='showClose' :close-on-click-modal='closeESC' :close-on-press-escape='closeESC'>
      <div slot="title" v-if="title&&!type" v-html="title"></div>
      <div slot="title" v-if="type&&!title" class="topTit"><img class="titIcon" :src="warnIcon"></div>
      <span v-html="msg"></span>
      <div class="dialog-footer footer" slot="footer">
        <el-button class="btn " type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: true,
      warnIcon: require('../../assets/image/onlineExam/warning.png')
    }
  },
  props:{
    msg: String,//消息体，支持HTML
    title: String,  //消息头，支持HTML
    confirm: Function, //确认回调
    showClose: { //是否展示关闭按钮
      type: Boolean,
      default: true
    },
    closeESC: { //是否可点击蒙层关闭
      type: Boolean,
      default: true
    },
    closeESC: { //是否可点击esc按钮关闭
      type: Boolean,
      default: true
    },
    type: String
  },
  methods: {
    close(){
      this.dialogVisible = false;
      document.body.removeChild(this.$el)
    },
    handleConfirm() {
      if (typeof this.confirm == 'function') {
        this.confirm(); 
      }
      this.close();
    }
  },
}
</script>
<style lang="less" scoped>
.el-dialog__wrapper /deep/ .el-dialog{
  margin-top: 300px !important;
  border-radius: 10px;
  .el-dialog__header {
    border-bottom: 1px solid rgba(23, 6, 6, .08);
    .el-dialog__title {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #170606;
    }
  }
  .el-dialog__body{
    padding: 30px 20px 0 20px;
  }
  .el-dialog__footer{
    padding: 0;
  }
}
.footer{
  width: 100%;
  height: 59px;
  border-top: 1px solid rgba(23, 6, 6, .08);
  .btn{
    width: 100%;
    height: 59px;
    font-size: 16px;
    text-align: center;
    font-weight: 600;
    color: #F06E6C;
    background-color: #fff;
    border-color: #fff;
    border-radius: 10px;
  }
}
.topTit{
  text-align: center;
  .titIcon{
    width: 36px;
    height: 31px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/msgModal/msgModal.vue